import { createAction, props } from '@ngrx/store';
import { IConstantsResponseItems } from '@modules/sanna/data/models/constants.interface';
import { IDiagnosticosDatosItem } from '@shared/interfaces/diagnosticos-api.interface';
import { IEspacialidades, IEspacialidadesItem } from '@sanna/data/models/sanna-ciudadano-api.interface';
import { IContingenciasItem } from '@sanna/data/models/sanna-contingencias-api.interface';
import {
  ICrearFormularioEmpleadorLicenciaBody,
  ICrearLicenciaContingencia,
  ILicenciaObtenerItem,
} from '@sanna/data/models/sanna-licencia-api.interface';
import { ILS, ILSENTITY, ILSValidationAdmin } from '@sanna/data/models/sanna.interfaces';
import {
  abstractResolutionConsultationResponse,
  abstractResolutionConsultationResponseItem,
} from '@modules/sanna/interface/abstract.interface';

export const LOAD_SANNA_LICENCES = createAction('[SANNA] Peticion Carga Licencias para Recepcionista');
export const LOAD_SANNA_LICENCES_SUCCESS = createAction(
  '[SANNA] Peticion Carga Licencias para Recepcionista (SUCCESS)',
  props<{ lsRecordsWithoutProcessing: ILS[] }>(),
);

export const LOAD_SANNA_LICENCES_FAIL = createAction(
  '[SANNA] Peticion Carga Licencias para Recepcionista (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Acciones para licencia Sanna en estado recepcionada y lista para digitalizar.
 */
export const LOAD_SANNA_LICENCES_TO_DIGITIZE = createAction(
  '[SANNA] Petición Carga Licencias para Digitalización',
  props<{ subcomisionesIds: number[] }>(),
);
export const LOAD_SANNA_LICENCES_TO_DIGITIZE_SUCCESS = createAction(
  '[SANNA]  Petición Carga Licencias para Digitalización (SUCCESS)',
  props<{ lsRecords: ILS[] }>(),
);
export const LOAD_SANNA_LICENCES_TO_DIGITIZE_FAIL = createAction(
  '[SANNA] Peticion Petición Carga Licencias para Digitalización (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Acciones para licencia Sanna en estado recepcionada y lista para digitar.
 */
export const LOAD_SANNA_LICENCES_TO_TYPE = createAction(
  '[SANNA] Petición Carga Licencias para Digitar',
  props<{ subcomisionesIds: number[] }>(),
);
export const LOAD_SANNA_LICENCES_TO_TYPE_SUCCESS = createAction(
  '[SANNA]  Petición Carga Licencias para Digitar (SUCCESS)',
  props<{ lsRecords: ILS[] }>(),
);
export const LOAD_SANNA_LICENCES_TO_TYPE_FAIL = createAction(
  '[SANNA] Peticion Petición Carga Licencias para Digitar (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Acciones para consumir datos constantes de formulario de licencia.
 */
export const LOAD_SANNA_LICENCES_CONSTANTS = createAction('[SANNA] Petición carga constantes de formularios');
export const LOAD_SANNA_LICENCES_CONSTANTS_SUCCESS = createAction(
  '[SANNA]  Petición carga constantes de formularios (SUCCESS)',
  props<{ constants: IConstantsResponseItems[] }>(),
);
export const LOAD_SANNA_LICENCES_CONSTANTS_FAIL = createAction(
  '[SANNA] Petición carga constantes de formularios (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Acciones para consumir datos de carga parcial de información licencia sanna.
 */
export const LOAD_SANNA_LICENSE = createAction(
  '[SANNA] Petición carga información parcial de licencia',
  props<{ folio: string }>(),
);
export const LOAD_SANNA_LICENSE_SUCCESS = createAction(
  '[SANNA]  Petición carga información parcial de licencia (SUCCESS)',
  props<{ license: ILicenciaObtenerItem[] }>(),
);
export const LOAD_SANNA_LICENSE_FAIL = createAction(
  '[SANNA] Petición carga información parcial de licencia (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Acciones para consumir servicio de diagnostico.
 */
export const LOAD_SANNA_DIAGNOSTIC = createAction('[SANNA DIAGNOSTICOS] Petición carga de dignosticos');
export const LOAD_SANNA_DIAGNOSTIC_SUCCESS = createAction(
  '[SANNA DIAGNOSTICOS]  Petición carga de dignosticos (SUCCESS)',
  props<{ diagnostics: IDiagnosticosDatosItem[] }>(),
);
export const LOAD_SANNA_DIAGNOSTIC_FAIL = createAction(
  '[SANNA DIAGNOSTICOS] Petición carga de dignosticos (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Acciones para consumir servicio de contingencias.
 */
export const LOAD_SANNA_CONTINGENCIES = createAction('[SANNA CONTINGENCIAS] Petición carga de contingencias');
export const LOAD_SANNA_CONTINGENCIES_SUCCESS = createAction(
  '[SANNA CONTINGENCIAS] Petición carga de contingencias (SUCCESS)',
  props<{ contingencies: IContingenciasItem[] }>(),
);
export const SELECT_SANNA_CONTINGENCIES = createAction(
  '[SANNA CONTINGENCIAS] Selección de contingencia',
  props<{ selectedContingencies: ICrearLicenciaContingencia }>(),
);
export const LOAD_SANNA_CONTINGENCIES_FAIL = createAction(
  '[SANNA CONTINGENCIAS] Petición carga de contingencias (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Validación Administrativa	/sanna/validacion-administrativa	/sanna/validation-admin
 */
export const LOAD_SANNA_LICENCES_VALIDATION_ADMIN = createAction(
  '[SANNA] Peticion Carga Licencias para Validación Administrativa',
  props<{ subcomisionesIds: number[] }>(),
);
export const LOAD_SANNA_LICENCES_VALIDATION_ADMIN_SUCCESS = createAction(
  '[SANNA] Peticion Carga Licencias para Validación Administrativa (SUCCESS)',
  props<{ lsRecordsValidationAdmin: ILSValidationAdmin[] }>(),
);

export const LOAD_SANNA_LICENCES_VALIDATION_ADMIN_FAIL = createAction(
  '[SANNA] Peticion Carga Licencias para Validación Administrativa (FAIL)',
  props<{ payload: any }>(),
);

export const LOAD_SANNA_LICENCES_VALIDATION_ADMIN_REVIEW = createAction(
  '[SANNA] Petición carga información parcial de licencia',
  props<{ folio: string }>(),
);
export const LOAD_SANNA_LICENCES_VALIDATION_ADMIN_REVIEW_SUCCESS = createAction(
  '[SANNA]  Petición carga información parcial de licencia (SUCCESS)',
  props<{ license: ILicenciaObtenerItem[] }>(),
);
export const LOAD_SANNA_LICENCES_VALIDATION_ADMIN_REVIEW_FAIL = createAction(
  '[SANNA] Petición carga información parcial de licencia (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Acciones para licencia Sanna para validar con usuario FSIL.
 */
export const LOAD_SANNA_LICENCES_TO_VALIDATE = createAction(
  '[SANNA] Petición Carga Licencias para validación FSIL',
  props<{ subcomisionesIds: number[] }>(),
);
export const LOAD_SANNA_LICENCES_TO_VALIDATE_SUCCESS = createAction(
  '[SANNA]  Petición Carga Licencias para para validación FSIL (SUCCESS)',
  props<{ lsValidationRecords: ILS[] }>(),
);
export const LOAD_SANNA_LICENCES_TO_VALIDATE_FAIL = createAction(
  '[SANNA] Peticion Petición Carga Licencias para para validación FSIL (FAIL)',
  props<{ payload: any }>(),
);

export const LOAD_MEDICAL_SPECIALITY = createAction('[SANNA] Petición Carga de especialidad medica');
export const LOAD_MEDICAL_SPECIALITY_SUCCESS = createAction(
  '[SANNA]  Petición Carga de especialidad medica (SUCCESS)',
  props<{ specialties: IEspacialidades }>(),
);

export const LOAD_MEDICAL_SPECIALITY_FAIL = createAction(
  '[SANNA] Peticion Carga de especialidad medica (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Acciones para consumir servicio de Validar íntegramente antecedentes de una LM.
 */
export const LOAD_SANNA_VALIDATION_COMPTROLLER_SUPPORT = createAction(
  '[SANNA] Petición Carga de Validación de apoyo a contralor',
  props<{ subcomisionesIds: number[] }>(),
);
export const LOAD_SANNA_VALIDATION_COMPTROLLER_SUPPORT_SUCCESS = createAction(
  '[SANNA] Petición Carga de Validación de apoyo a contralor (SUCCESS)',
  props<{ lsValidationComptrollerSupport: ILS[] }>(),
);

export const LOAD_SANNA_VALIDATION_COMPTROLLER_SUPPORT_FAIL = createAction(
  '[SANNA] Petición Carga de Validación de apoyo a contralor (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Acciones para consumir servicio de Validación perfil contralor.
 */
export const LOAD_SANNA_VALIDATION_COMPTROLLER = createAction(
  '[SANNA] Petición Carga de Validación licencia contralor',
  props<{ subcomisionesIds: number[] }>(),
);
export const LOAD_SANNA_VALIDATION_COMPTROLLER_SUCCESS = createAction(
  '[SANNA] Petición Carga de Validación licencia contralor (SUCCESS)',
  props<{ lsValidationComptroller: ILS[] }>(),
);

export const LOAD_SANNA_VALIDATION_COMPTROLLER_FAIL = createAction(
  '[SANNA] Petición Carga de Validación licencia contralor (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Acciones para consumir servicio de Validación perfil presidente.
 */
export const LOAD_SANNA_VALIDATION_PRESIDENT = createAction(
  '[SANNA] Petición Carga de Validación licencia presidente',
  props<{ subcomisionesIds: number[] }>(),
);
export const LOAD_SANNA_VALIDATION_PRESIDENT_SUCCESS = createAction(
  '[SANNA] Petición Carga de Validación licencia presidente (SUCCESS)',
  props<{ lsValidationPresident: ILS[] }>(),
);

export const LOAD_SANNA_VALIDATION_PRESIDENT_FAIL = createAction(
  '[SANNA] Petición Carga de Validación licencia presidente (FAIL)',
  props<{ payload: any }>(),
);

export const LOAD_SANNA_ZONE_C = createAction(
  '[SANNA] Petición Carga de zona c licencia médica sanna',
  props<{ folio: string }>(),
);
export const LOAD_SANNA_ZONE_C_SUCCESS = createAction(
  '[SANNA] Petición Carga de zona c licencia médica sanna (SUCCESS)',
  props<{ lsZoneC: ICrearFormularioEmpleadorLicenciaBody }>(),
);

export const LOAD_SANNA_ZONE_C_FAIL = createAction(
  '[SANNA] Petición Carga de zona c licencia médica sanna (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Acciones para licencia Sanna para validar con usuario FSIL.
 */
export const LOAD_SANNA_DCN_REFERRER = createAction(
  '[SANNA] Petición Carga Licencias para Referente DCN',
  props<{ subcomisionesIds: number[] }>(),
);
export const LOAD_SANNA_DCN_REFERRER_SUCCESS = createAction(
  '[SANNA]  Petición Carga Licencias para Referente DCN (SUCCESS)',
  props<{ lsDcnReferrer: ILS[] }>(),
);
export const LOAD_SANNA_DCN_REFERRER_FAIL = createAction(
  '[SANNA] Peticion Petición Carga Licencias para Referente DCN (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Acciones para licencia Sanna para Entidad Pagadora
 */
export const LOAD_SANNA_PAYING_ENTITY_CONSULTATION = createAction(
  '[SANNA] Petición Carga Licencias para Entidad Pagadora (Consulta de Resoluciones)',
  props<{
    entidadesIds: string[];
    fechaInicial: string;
    fechaFinal: string;
    licenciaFolio: string;
    trabajadorRut: string;
    estadoLicencia: string;
  }>(),
);
export const LOAD_SANNA_PAYING_ENTITY_CONSULTATION_SUCCESS = createAction(
  '[SANNA] Petición Carga Licencias para Entidad Pagadora (Consulta de Resoluciones) (SUCCESS)',
  props<{ lsRecords: ILSENTITY[] }>(),
);
export const LOAD_SANNA_PAYING_ENTITY_CONSULTATION_FAIL = createAction(
  '[SANNA] Petición Carga Licencias para Entidad Pagadora (Consulta de Resoluciones) (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Acciones para licencia Sanna para Entidad Pagadora
 */
export const LOAD_SANNA_PAYING_ENTITY_PROCESSING = createAction(
  '[SANNA] Petición Carga Licencias para Entidad Pagadora (Tramitación de Resoluciones)',
  props<{
    entidadesIds: string[];
    fechaInicial: string;
    fechaFinal: string;
    licenciaFolio: string;
    trabajadorRut: string;
    estadoLicencia: string;
  }>(),
);
export const LOAD_SANNA_PAYING_ENTITY_PROCESSING_SUCCESS = createAction(
  '[SANNA] Petición Carga Licencias para Entidad Pagadora  (Tramitación de Resoluciones) (SUCCESS)',
  props<{ lsRecords: ILSENTITY[] }>(),
);
export const LOAD_SANNA_PAYING_ENTITY_PROCESSING_FAIL = createAction(
  '[SANNA] Petición Carga Licencias para Entidad Pagadora  (Tramitación de Resoluciones) (FAIL)',
  props<{ payload: any }>(),
);

/**
 * Acciones para licencia Sanna para Consulta de Resoluciones
 */
export const LOAD_SANNA_ABSTRACT_RESOL_CONSUL = createAction(
  '[SANNA] Petición Carga Licencias para Consulta de Resoluciones',
  props<{ folio: string }>(),
);
export const LOAD_SANNA_ABSTRACT_RESOL_CONSUL_SUCCESS = createAction(
  '[SANNA]  Petición Carga Licencias para Consulta de Resoluciones (SUCCESS)',
  props<{ LsAbstractResolutionConsultation: abstractResolutionConsultationResponseItem[] }>(),
);
export const LOAD_SANNA_ABSTRACT_RESOL_CONSUL_FAIL = createAction(
  '[SANNA] Petición Carga Licencias para Consulta de Resoluciones (FAIL)',
  props<{ payload: any }>(),
);
